module.exports = __webpack_public_path__ + "static/media/icon-services-bubble.f0f9900d.svg";